import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import ReactModal from 'react-modal';

import { router } from 'config/router';
import { setupAxiosInterceptors } from 'config/axios';

import store from 'store';

import 'config/i18n';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-toward.css';
import 'swiper/css';
import 'assets/styles/styles.scss';

setupAxiosInterceptors();

ReactModal.setAppElement('#bef-app');

const container = document.getElementById('bef-app');
if (!container) {
  throw new Error('Root element #bef-app not found');
}
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
